<template>
  <div>
    <warehouse-table v-show="activeKey===1" ref="list" :addition-picking-modes="additionPickingModes" @add="add" @config="config" @edit="edit"/>
    <warehouse-detail v-show="activeKey===2" ref="detail" :addition-picking-modes="additionPickingModes" :container-types="containerTypes" :order-strategies="orderStrategies" :wave-strategies="waveStrategies" @back="back"/>
    <warehouse-extra v-show="activeKey===3" ref="extra" :container-types="containerTypes" :conveyors="conveyors" :directions="directions" :distribution-types="distributionTypes" :flow-types="flowTypes" :inspection-types="inspectionTypes" :order-properties="orderProperties" :pack-types="packTypes" :picking-modes="pickingModes" :pickup-modes="pickupModes" :regions="regions" @back="back"/>
  </div>
</template>
<script>
import { findAll, findEnum, findOne } from '@/api/Api'
import WarehouseTable from '@/views/basedata/warehouse/WarehouseTable.vue'
import WarehouseDetail from '@/views/basedata/warehouse/WarehouseDetail.vue'
import WarehouseExtra from '@/views/basedata/warehouse/WarehouseExtra.vue'

export default {
  name: 'WarehouseBaseData',
  components: { WarehouseTable, WarehouseDetail, WarehouseExtra },
  data() {
    return {
      activeKey: 1,
      orderStrategies: [],
      waveStrategies: [],
      containerTypes: [],
      pickupModes: [],
      regions: [],
      orderProperties: [],
      additionPickingModes: [],
      inspectionTypes: [],
      pickingModes: [],
      flowTypes: [],
      packTypes: [],
      distributionTypes: [],
      conveyors: [],
      directions: []
    }
  },
  created() {
    findOne('fieldFactory', { no: 'ORDER_STRATEGY' }).then(res => {
      if (res.success) {
        this.orderStrategies = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
      return findOne('fieldFactory', { no: 'WAVE_STRATEGY' })
    }).then(res => {
      if (res.success) {
        this.waveStrategies = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
      return findAll('containerTypeFactory', { available: true })
    }).then(res => {
      if (res.success) {
        this.containerTypes = res.result.map(item => {
          return { label: item.name, value: item.id }
        })
      }
      return findOne('fieldFactory', { no: 'PICKUP_MODE' })
    }).then(res => {
      if (res.success) {
        this.pickupModes = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
      return findOne('fieldFactory', { no: 'ZONE_REGION' })
    }).then(res => {
      if (res.success) {
        this.regions = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
      return findOne('fieldFactory', { no: 'ORDER_PROPERTY' })
    }).then(res => {
      if (res.success) {
        this.orderProperties = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
      return findEnum('AdditionPickingMode')
    }).then(res => {
      if (res.success) {
        this.additionPickingModes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
      return findEnum('InspectionType')
    }).then(res => {
      if (res.success) {
        this.inspectionTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
      return findEnum('PickingMode')
    }).then(res => {
      if (res.success) {
        this.pickingModes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
      return findEnum('FlowType')
    }).then(res => {
      if (res.success) {
        this.flowTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
      return findEnum('PackType')
    }).then(res => {
      if (res.success) {
        this.packTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
      return findEnum('DistributionType')
    }).then(res => {
      if (res.success) {
        this.distributionTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
      return findOne('fieldFactory', { no: 'CONVEYOR' })
    }).then(res => {
      if (res.success) {
        this.conveyors = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
      return findOne('fieldFactory', { no: 'DIRECTION' })
    }).then(res => {
      if (res.success) {
        this.directions = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(id, copy) {
      this.activeKey = 2
      this.$refs.detail.refresh(id, copy)
    },
    config(warehouse) {
      this.activeKey = 3
      this.$refs.extra.refresh(warehouse)
    }
  }
}
</script>